// extracted by mini-css-extract-plugin
module.exports = {"grid":"GridBackground_grid__Yl2PG"};